import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import Loader from "common/components/Loader";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import DesktopTable from "./DesktopTable";
import MobileList from "./MobileList";

import type { Invoice } from "../../types";

import NoInvoicesFound from "assets/images/empty-placeholders/no-invoices-found.png";

export default function Invoices({
  invoices,
  isLoadingInvoices,
  isInvoicesError,
  refetchInvoices,
}: {
  invoices: Invoice[];
  isLoadingInvoices: boolean;
  isInvoicesError: boolean;
  refetchInvoices: () => void;
}) {
  const isDesktop = useTwBreakpoint("lg");

  if (isInvoicesError) {
    return (
      <ErrorPlaceholder
        errorMessage="Could not display invoices"
        onRetry={refetchInvoices}
      />
    );
  } else if (isLoadingInvoices) {
    return <Loader />;
  } else if (!invoices || !invoices.length) {
    return (
      <EmptyPlaceholder
        title="No invoices found"
        subtitle="There are no invoices to display"
        imageSrc={NoInvoicesFound}
      />
    );
  }

  const Table = isDesktop ? DesktopTable : MobileList;

  return <Table invoices={invoices} />;
}
